import { render, staticRenderFns } from "./show-release-notes.vue?vue&type=template&id=2d2135a6&"
import script from "./show-release-notes.vue?vue&type=script&lang=js&"
export * from "./show-release-notes.vue?vue&type=script&lang=js&"
import style0 from "./show-release-notes.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VCheckbox,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d2135a6')) {
      api.createRecord('2d2135a6', component.options)
    } else {
      api.reload('2d2135a6', component.options)
    }
    module.hot.accept("./show-release-notes.vue?vue&type=template&id=2d2135a6&", function () {
      api.rerender('2d2135a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/show-release-notes.vue"
export default component.exports